import axios from "axios"

import { devMode } from "./base"

const baseDomain = `https://m-b2b${devMode ? "-dev" : ""}.mioto.vn`;
const walletDomain = `https://m-wallet${devMode ? "-dev" : ""}.mioto.vn`

export function getBalance() {
    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/biz/balance`
    })
}

export function getInvoiceByMonth(month) {
    const monthParams = month !== 0 ? `month=${month}` : "";
    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/biz/invoice?${monthParams}`
    })
}

export function getRequestWithdraw() {
	return axios({
		withCredentials: true, 
		method: "GET",
		url: `${walletDomain}/owner/get-request-withdraw`
	})
}

export function withdrawMoney(cancel, withdrawInfo){
    const isCancel = cancel !== undefined ? `cancel=${cancel}` : 0;
    const amount = withdrawInfo && withdrawInfo.amount !== undefined ? `&amount=${withdrawInfo.amount}` : "";
		const method = withdrawInfo && withdrawInfo.method !== undefined ? `&method=${withdrawInfo.method}` : "";
    return axios({
        withCredentials: true,
        method: "POST",
        url: `${walletDomain}/owner/request-withdraw?${isCancel}${amount}${method}`
    })
}

export function updateBankInfo(withdrawInfo) {
	const accountName = withdrawInfo && withdrawInfo.accountName !== undefined ? `&accountName=${withdrawInfo.accountName}` : "";
	const accountNumber = withdrawInfo && withdrawInfo.accountNumber !== undefined ? `&accountNumber=${withdrawInfo.accountNumber}` : "";
	const bankName = withdrawInfo && withdrawInfo.bankName !== undefined ? `&bankName=${withdrawInfo.bankName}` : "";
	const bankProvince = withdrawInfo &&  withdrawInfo.bankProvince !== undefined ? `&bankProvince=${withdrawInfo.bankProvince}` : "";
	const bankBranch = withdrawInfo && withdrawInfo.bankBranch !== undefined ? `&bankBranch=${withdrawInfo.bankBranch}` : "";
	return axios({
		withCredentials: true, 
		method: "POST", 
		url: `${walletDomain}/owner/update-request-withdraw/bank?${accountName}${accountNumber}${bankName}${bankProvince}${bankBranch}`
	})
}

export function updateViettelpayInfo(cancel, phoneNumber) {
	const isCancel = cancel !== undefined ? `cancel=${cancel}` : 0;
	return axios({
		withCredentials: true, 
		method: "POST",
		url: `${walletDomain}/owner/update-request-withdraw/viettelpay?${isCancel}&phoneNumber=${phoneNumber}`
	})
}




// WEBPACK FOOTER //
// ./src/model/wallet.js